import React from "react";

const iconColor = "#64ffda";
const ArchiveItem = ({
  title,
  description,
  usecase,
  live,
  video,
  poster,
  reward,
  techList,
}) => {
  return (
    <li>
      <div className="archive-inner">
        {reward && (
          <div className="ribbon ribbon-top-left">
            <span>{reward}</span>
          </div>
        )}
        <div className="overlay animate__animated animate__fadeIn">
          <div className="preview">{poster && <img src={poster} alt="" />}</div>
        </div>
        <div className="header">
          <div className="project-links">
            {usecase && (
              <a
                href={usecase}
                target="_blank"
                rel="noreferrer"
                title="Visit the project"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 511.998 511.998"
                >
                  <g>
                    <g>
                      <path
                        fill={iconColor}
                        d="M499.839,288.601l-53.456-32.602l53.456-32.602c7.552-4.605,12.159-12.813,12.159-21.659
                                c0-8.846-4.609-17.054-12.159-21.659L269.21,39.423c-8.113-4.947-18.307-4.947-26.42,0L12.159,180.079
                                C4.609,184.685,0,192.893,0,201.738c0,8.846,4.609,17.054,12.159,21.659l53.456,32.602l-53.456,32.602
                                C4.609,293.206,0,301.414,0,310.26c0,8.846,4.609,17.054,12.159,21.659l230.629,140.657c4.056,2.473,8.633,3.711,13.211,3.711
                                s9.153-1.236,13.211-3.711l230.629-140.657c7.552-4.605,12.159-12.813,12.159-21.659
                                C511.998,301.414,507.391,293.206,499.839,288.601z M255.999,90.798l181.906,110.94L255.999,312.68L74.095,201.738L255.999,90.798
                                z M255.999,421.2L74.095,310.26l40.245-24.544l128.45,78.34c4.056,2.473,8.633,3.711,13.211,3.711s9.153-1.236,13.211-3.711
                                l128.45-78.34l40.245,24.544L255.999,421.2z"
                      />
                    </g>
                  </g>
                </svg>
              </a>
            )}
            {live && (
              <a
                href={live}
                target="_blank"
                rel="noreferrer"
                title={`Live:${title}`}
              >
                <svg
                  x="0px"
                  y="0px"
                  width="32px"
                  height="32px"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill={iconColor}
                    d="M26.75,5.25c-4.081-2.077-9.546-1.767-13.471,2.158c-0.983,0.983-1.773,1.914-2.424,2.79
	l-0.028-0.028c-1.56-1.56-4.097-1.56-5.657,0s-1.56,4.097,0,5.657l0.51,0.51l2.671-1.335c-0.374,1.324-0.356,2.079-0.258,2.776
	l6.131,6.131c0.696,0.097,1.451,0.116,2.776-0.258l-1.336,2.671l0.51,0.51c1.56,1.56,4.097,1.56,5.657,0s1.56-4.097,0-5.657
	l-0.028-0.028c0.876-0.652,1.807-1.441,2.79-2.424C28.464,14.85,28.862,9.398,26.75,5.25z M6.187,13.847
	c-0.346-0.741-0.214-1.652,0.397-2.263c0.78-0.78,2.049-0.78,2.828,0l0.31,0.31c-0.051,0.087-0.108,0.177-0.156,0.262L6.187,13.847z
	 M20.416,22.588c0.78,0.78,0.78,2.048,0,2.828c-0.611,0.611-1.522,0.743-2.263,0.397l1.691-3.38
	c0.085-0.048,0.175-0.105,0.262-0.156L20.416,22.588z M15.115,21.971l-5.09-5.09c0.043-0.91,0.526-3.917,4.668-8.06
	c4.3-4.3,9.287-2.611,10.559-2.074c0.538,1.276,2.225,6.261-2.074,10.559C19.06,21.425,16.043,21.923,15.115,21.971z M16.643,12.357
	c0,1.654,1.346,3,3,3c1.654,0,3-1.346,3-3c0-1.654-1.346-3-3-3C17.989,9.357,16.643,10.703,16.643,12.357z M20.643,12.357
	c0,0.551-0.448,1-1,1c-0.552,0-1-0.449-1-1c0-0.551,0.448-1,1-1S20.643,11.806,20.643,12.357z M4.879,22.878
	c-1.007,1.007-1.02,3.522-1,4.27l0.027,0.946l1.164,0.029c1.391,0,3.223-0.174,4.051-1.001c1.175-1.176,1.17-3.072,0-4.243
	C7.988,21.745,6.012,21.746,4.879,22.878z M7.708,25.706c-0.152,0.139-0.787,0.323-1.805,0.391c0.062-0.849,0.215-1.61,0.39-1.803
	c0.39-0.389,1.021-0.392,1.414,0C8.099,24.683,8.097,25.319,7.708,25.706z"
                  />
                </svg>
              </a>
            )}
            {video !== null && (
              <a
                href={video}
                target="_blank"
                rel="noreferrer"
                title="Watch video"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 310 310"
                >
                  <g>
                    <path
                      fill={iconColor}
                      d="M297.917,64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359,0-61.369,5.776-72.517,19.938
                                C0,79.663,0,100.008,0,128.166v53.669c0,54.551,12.896,82.248,83.386,82.248h143.226c34.216,0,53.176-4.788,65.442-16.527
                                C304.633,235.518,310,215.863,310,181.835v-53.669C310,98.471,309.159,78.006,297.917,64.645z M199.021,162.41l-65.038,33.991
                                c-1.454,0.76-3.044,1.137-4.632,1.137c-1.798,0-3.592-0.484-5.181-1.446c-2.992-1.813-4.819-5.056-4.819-8.554v-67.764
                                c0-3.492,1.822-6.732,4.808-8.546c2.987-1.814,6.702-1.938,9.801-0.328l65.038,33.772c3.309,1.718,5.387,5.134,5.392,8.861
                                C204.394,157.263,202.325,160.684,199.021,162.41z"
                    />
                  </g>
                </svg>
              </a>
            )}
          </div>
          <h3>{title}</h3>
        </div>
        <p>{description}</p>
        <div className="project-tech-list">
          {techList.map((detail) => {
            return (
              <ul key={detail.id}>
                <li>{detail.content}</li>
              </ul>
            );
          })}
        </div>
      </div>
    </li>
  );
};
export default ArchiveItem;
